const HOSTNAME = typeof window !== 'undefined' ? window.location.hostname : '';
const STAGING_HOSTS = new Set([
  'eshot-staging-trovex.web.app',
  'localhost',
  '127.0.0.1',
]);

export const ESHOT_ENVIRONMENT =
  STAGING_HOSTS.has(HOSTNAME) ? 'staging' : 'production';

export const IS_STAGING = ESHOT_ENVIRONMENT === 'staging';
export const IS_PRODUCTION = ESHOT_ENVIRONMENT === 'production';
